import React from 'react';
import { BodyM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';

interface IPinPukRowProps {
	label: string;
	value: string;
}

const PinPukRow = ({ label, value }: IPinPukRowProps) => {
	return (
		<div>
			<BodyM>{translate('colon', label)}</BodyM>
			<BodyM color="disabled-light">{value}</BodyM>
		</div>
	);
};

export default PinPukRow;
